import { ActionAPI, TextAPI, ToastNotificationAPI } from '@philips-internal/oswald-ui-components';
import { ButtonTheme } from '@philips-internal/oswald-ui-constants';
import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { ClickEvent, MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { BrokerService, HttpService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { Inject } from '@odinjs/odin';

import { FragmentNames, GuidanceToThePatientAliases } from '../../codegen';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import TaskItem from '../../interfaces/task-item';
import { TasksUtils } from '../../utils/tasks-utils';
import BaseController from '../BaseController';
import { DYNAMIC_STEP_IDENTIFIER } from './tasks-controller';

import './guidance-to-patient.css';
import { BS_TASK_LIST_BLOCK_PROFILE_EDITING } from '../../constants/application-constants';

@Controller({ component: GuidanceToThePatientAliases.GUIDANCE_TO_THE_PATIENT_LAYOUT, fragment: FragmentNames.GUIDANCE_TO_THE_PATIENT })
export default class GuidanceToThePatientController extends BaseController {

  disableCheckAction = true;

  @Inject(GuidanceToThePatientAliases.GUIDANCE_TEXT)
    guidanceText!: TextAPI;

  @Inject(GuidanceToThePatientAliases.TOAST_NOTIFICATION)
    toastNotificationBlockMessageApi!: ToastNotificationAPI;

  @OnMount(GuidanceToThePatientAliases.CHECK_AS_READ_ACTION)
  onLayoutMount(event: MountEvent): void {
    const checkActionAPI = event.target as ActionAPI;
    const identifier = this.context.get('identifier') as string;
    const nrSequencia = identifier.split(DYNAMIC_STEP_IDENTIFIER.GUIDANCE_TO_THE_PATIENT.concat('-'))[1];
    const taskList = this.context.get('taskList') as TaskItem[];
    const guidanceTask = taskList.find(task => task.nrSequencia === Number(nrSequencia));

    if (guidanceTask?.dsOrientacao) {
      this.guidanceText.setValue(guidanceTask.dsOrientacao);
    }

    if (guidanceTask) {
      TasksUtils.setInitialActionStatus({
        checkActionAPI,
        onBlocked: () => {
          this.disableCheckAction = true;
          this.toastNotificationBlockMessageApi.setVisible(true);
          BrokerService.publishToTopic(BS_TASK_LIST_BLOCK_PROFILE_EDITING, true);
        },
        onCompleted: () => {
          checkActionAPI.setText(MessageService.translate('patient.checked'));
          checkActionAPI.setButtonTheme(ButtonTheme.ACCENT);
          this.disableCheckAction = true;
        },
        onPending: () => {
          this.disableCheckAction = false;
          this.context.set({ nrSequencia });
        },
        taskItem: guidanceTask,
      });
    }
  }

  @OnClick(GuidanceToThePatientAliases.CHECK_AS_READ_ACTION)
  onClickCheckAction(event: ClickEvent): void {
    if (this.disableCheckAction) return;

    const checkAction = event.target as ActionAPI;
    const identifier = this.context.get('identifier') as string;
    const nrSequencia = this.context.get('nrSequencia');

    HttpService.put(APPLICATION_ENDPOINTS.UPDATE_TASK_STATUS, { nrSequencia }).then(() => {
      TasksUtils.setActionChecked(checkAction, identifier);
      this.disableCheckAction = true;
    });
  }
}
